import _ from 'lodash'
import { useSlideStore } from '~/store/slide'
import { useWishStore } from '~/store/wish'

export const useSlideModeB = () => {
  const slideStore = useSlideStore()
  const wishStore = useWishStore()


  function main() {
    slideStore.index++
    watchIndexAndViewMode();
    slideStore.restore_Previous_View_And_Save_If_New_Wish_Avaliable();

    let newWishList = wishStore.getNewDocIdList()
    let currentView = newWishList.length > 0 ? 'new_wish' : 'wish'

    if(currentView === 'new_wish') {
      slideStore.showNewWishIcon = true
      const newWishId = newWishList[0]
      const newWishData = wishStore.getWishDataById(newWishId)
      wishStore.newWishes.shift();

      return {
        type: 'wish',
        data: newWishData,
      }
    }


    slideStore.checkNextSlide()
    const docId = wishStore.queue.shift()
    const wishData = wishStore.getWishDataById(docId)
    return {
      type: 'wish',
      data: wishData,
    }
  }

  function watchIndexAndViewMode() {

    // toggle view mode 
    let newVal = slideStore.index

    slideStore.showNewWishIcon = false
    slideStore.view = 'wish'

    if (newVal >= slideStore.limit) {
      slideStore.index = 0
    }

    slideStore.limit = slideStore.itemLimit
  }


  return {
    main,
  }

}